export const isStringEmpty = (str) => {
  return !str || str.trim().length === 0;
};
